"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[536],{

/***/ 26484:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(90908);
var icon = __webpack_require__(33634);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(96742);
__webpack_require__(24774);

const DISLIKE_OUTLINED = 'M10.2353 20L9.35294 19.1367C9.13072 18.9193 9.01961 18.6443 9.01961 18.3118V18.0432L9.82353 14.3789H4.64706C4.20261 14.3789 3.81699 14.2254 3.4902 13.9185C3.1634 13.6115 3 13.2406 3 12.8058L3.03922 12.729H3V11.1942C3 10.9896 3.03921 10.7914 3.11765 10.5995L5.60784 4.97842C5.71242 4.68425 5.90196 4.44764 6.17647 4.26859C6.45098 4.08953 6.75817 4 7.09804 4H14.451C14.8954 4 15.281 4.15987 15.6078 4.47962C15.9346 4.79936 16.098 5.17666 16.098 5.61151V13.5923C16.098 14.0016 15.9346 14.3789 15.6078 14.7242L10.2353 20ZM17.7059 13.5923V4H21V13.5923H17.7059ZM10.6725 17.5011L14.5027 13.7408C14.568 13.6717 14.5899 13.6377 14.596 13.6112L14.598 13.5923V5.61151C14.598 5.57585 14.5955 5.56103 14.5727 5.53478L14.5424 5.50352C14.5061 5.46794 14.4949 5.45818 14.475 5.45553L7.09804 5.45455L7.05317 5.45786L7.03705 5.46275V5.46275L7.01775 5.47345L6.98605 5.55253L4.51207 11.1356L4.50272 11.1652L4.5 11.1942V12.3927L4.50165 12.4006C4.53184 12.5251 4.54529 12.6543 4.54001 12.7852L4.53375 12.8735C4.57043 12.9081 4.58639 12.9194 4.61416 12.9229L4.64706 12.9244H9.82353C10.7409 12.9244 11.4341 13.7124 11.3096 14.5774L11.2907 14.6816L10.6725 17.5011Z';
const IconDislikeOutlined = lib.variant('IconDislikeOutlined', icon.Icon, {
    path: DISLIKE_OUTLINED,
});

exports.R = IconDislikeOutlined;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 59141:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(90908);
var icon = __webpack_require__(33634);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(96742);
__webpack_require__(24774);

const LIKE_OUTLINED = 'M13.7647 4L14.6471 4.86331C14.8693 5.08074 14.9804 5.35571 14.9804 5.68825V5.95683L14.1765 9.6211H19.3529C19.7974 9.6211 20.183 9.77458 20.5098 10.0815C20.8366 10.3885 21 10.7594 21 11.1942L20.9608 11.271H21V12.8058C21 13.0104 20.9608 13.2086 20.8824 13.4005L18.3922 19.0216C18.2876 19.3157 18.098 19.5524 17.8235 19.7314C17.549 19.9105 17.2418 20 16.902 20H9.54902C9.10457 20 8.71895 19.8401 8.39216 19.5204C8.06536 19.2006 7.90196 18.8233 7.90196 18.3885V10.4077C7.90196 9.9984 8.06536 9.6211 8.39216 9.27578L13.7647 4ZM6.29412 10.4077V20H3V10.4077H6.29412ZM13.3275 6.49891L9.49733 10.2592C9.43197 10.3283 9.41015 10.3623 9.40404 10.3888L9.40196 10.4077V18.3885C9.40196 18.4242 9.40452 18.439 9.42733 18.4652L9.45756 18.4965C9.49392 18.5321 9.50509 18.5418 9.52497 18.5445L9.54902 18.5455H16.902L16.9468 18.5421C16.9526 18.5409 16.9579 18.5393 16.963 18.5373L16.9823 18.5265L17.0139 18.4475L19.4879 12.8644L19.4973 12.8348L19.5 12.8058V11.6073L19.4983 11.5994C19.4682 11.4749 19.4547 11.3457 19.46 11.2148L19.4662 11.1265C19.4296 11.0919 19.4136 11.0806 19.3858 11.0771L19.3529 11.0756H14.1765C13.2591 11.0756 12.5659 10.2876 12.6904 9.42256L12.7093 9.31843L13.3275 6.49891Z';
const IconLikeOutlined = lib.variant('IconLikeOutlined', icon.Icon, {
    path: LIKE_OUTLINED,
});

exports.q = IconLikeOutlined;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 40000:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(90908);
var icon = __webpack_require__(33634);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(96742);
__webpack_require__(24774);

const STAR = 'M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z';
const IconStar = lib.variant('IconStar', icon.Icon, {
    path: STAR,
});

exports.G = IconStar;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 11341:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": () => (/* binding */ Badge)
/* harmony export */ });
/* unused harmony export Text */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96742);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25349);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21541);
/* harmony import */ var src_areas_expert_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46674);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    font-size: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var Badge = function(props) {
    var type = props.type;
    var t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il).t;
    var text = (0,src_areas_expert_utils__WEBPACK_IMPORTED_MODULE_5__/* .getTranslationByContentType */ .r)(type, t);
    return text ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, null, text) : null;
};
var Text = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__.TitleMediumText).withConfig({
    displayName: "Text",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .layout.measurements.fontSizeMedium */ .bK.measurements.fontSizeMedium, function(p) {
    return p.theme.colors.maybeBlue700;
});


/***/ }),

/***/ 53973:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ expert_avatar)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./src/components/user-avatar/index.tsx + 1 modules
var user_avatar = __webpack_require__(60738);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/areas/expert/components/expert-avatar/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  height: fit-content;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ExpertAvatar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ExpertAvatar",
    componentId: "sc-0-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/areas/expert/components/expert-avatar/index.tsx





var expert_avatar_ExpertAvatar = function(param) {
    var avatar = param.avatar, className = param.className, displayName = param.displayName, link = param.link, size = param.size;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), renderMode = ref.renderMode, linkTo = ref.linkTo;
    var children = /*#__PURE__*/ react.createElement(user_avatar/* UserAvatar */.Y, {
        size: size,
        avatar: avatar,
        displayName: displayName
    });
    return /*#__PURE__*/ react.createElement(ExpertAvatar, {
        className: className
    }, link ? /*#__PURE__*/ react.createElement(clickable/* Clickable */.P, {
        to: linkTo("expertProfile", {
            semantic_id: link || ""
        }, renderMode === "native" ? {
            view: "native"
        } : undefined)
    }, children) : children);
};
/* harmony default export */ var expert_avatar = (expert_avatar_ExpertAvatar);


/***/ }),

/***/ 8454:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": () => (/* binding */ ExpertUserCard)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./src/areas/expert/components/expert-avatar/index.tsx + 1 modules
var expert_avatar = __webpack_require__(53973);
// EXTERNAL MODULE: ./src/areas/expert/types.ts
var types = __webpack_require__(54712);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/expert/components/expert-user-card/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    align-self: center;\n    grid-area: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  grid-area: 1 / 1 / 3 / 2;\n  align-self: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    display: grid;\n    grid-template-columns: ",
        "px 1fr;\n    grid-template-rows: auto auto;\n    column-gap: ",
        ";\n    margin-left: ",
        ";\n    z-index: ",
        ";\n\n    p {\n      margin: 0;\n    }\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    ",
        "\n    max-height: ",
        "px;\n\n    &[href]:hover {\n      ",
        " {\n        color: ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var USER_AVATAR_SIZE_SMALL = 32;
var USER_AVATAR_SIZE_MEDIUM = 48;
var Title = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Title",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject(), props.$showSubtitle ? "1 / 2 / 2 / 3" : "1 / 2 / 3 / 3");
});
var Subtitle = (0,styled_components_browser_esm["default"])(variants.CaptionText).withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject1(), props.$size === types/* ExpertUserCardSize.MEDIUM */.M.MEDIUM ? base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal : base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall);
});
var Avatar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Avatar",
    componentId: "sc-0-2"
})(_templateObject2());
var Expert = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Expert",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject3(), props.$size, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, props.$overlap ? "-".concat(props.$size * props.$overlap / 2, "px") : "0", props.$index);
});
var Container = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "Container",
    componentId: "sc-0-4"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject4(), props.$pointer ? "cursor: pointer;" : "", props.$size, Title, props.theme.text.callToActionHover);
});

;// CONCATENATED MODULE: ./src/areas/expert/components/expert-user-card/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}








var ExpertUserCard = function(props) {
    var className = props.className, customTitle = props.customTitle, experts = props.experts, _size = props.size, size = _size === void 0 ? types/* ExpertUserCardSize.SMALL */.M.SMALL : _size, subtitle = props.subtitle, _pointer = props.pointer, pointer = _pointer === void 0 ? false : _pointer;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, renderMode = ref.renderMode, linkTo = ref.linkTo;
    var avatarSize = size === types/* ExpertUserCardSize.MEDIUM */.M.MEDIUM ? USER_AVATAR_SIZE_MEDIUM : USER_AVATAR_SIZE_SMALL;
    var container = experts.length === 1 ? clickable/* Clickable */.P : "div";
    var containerProps = experts.length === 1 && experts[0].url ? {
        to: linkTo("expertProfile", {
            semantic_id: experts[0].url
        }, renderMode === "native" ? {
            view: "native"
        } : undefined),
        isExternal: renderMode === "native",
        onClick: function() {
            if (experts[0].url) {
                (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.EXPERT_PROFILE_GO_TO */.U.EXPERT_PROFILE_GO_TO,
                    nextPage: experts[0].url
                });
            }
        }
    } : undefined;
    var getSingularExpertText = function(expert) {
        if (customTitle) return /*#__PURE__*/ react.createElement(Title, {
            $showSubtitle: false
        }, customTitle);
        return /*#__PURE__*/ react.createElement(react.Fragment, null, size === types/* ExpertUserCardSize.MEDIUM */.M.MEDIUM ? /*#__PURE__*/ react.createElement(Title, {
            $showSubtitle: Boolean(subtitle)
        }, /*#__PURE__*/ react.createElement(variants.TitleMediumText, {
            behavior: variants.Behavior.Oneline
        }, expert.name)) : /*#__PURE__*/ react.createElement(Title, {
            $showSubtitle: Boolean(subtitle)
        }, /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
            behavior: variants.Behavior.Oneline
        }, expert.name)));
    };
    var getPluralExpertText = function() {
        if (customTitle) return /*#__PURE__*/ react.createElement(Title, {
            $showSubtitle: false
        }, customTitle);
        return /*#__PURE__*/ react.createElement(react.Fragment, null, size === types/* ExpertUserCardSize.MEDIUM */.M.MEDIUM ? /*#__PURE__*/ react.createElement(Title, null, /*#__PURE__*/ react.createElement(variants.TitleMediumText, {
            behavior: variants.Behavior.Oneline
        }, t("expert", "guide.lists-expert-plural", {
            count: experts.length
        }))) : /*#__PURE__*/ react.createElement(Title, null, /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
            behavior: variants.Behavior.Oneline
        }, t("expert", "guide.lists-expert-plural", {
            count: experts.length
        }))));
    };
    return /*#__PURE__*/ react.createElement(Container, _extends({
        className: className,
        as: container,
        $size: avatarSize,
        $pointer: experts.length === 1 && pointer
    }, containerProps), experts.map(function(expert, index) {
        return /*#__PURE__*/ react.createElement(Expert, {
            key: expert.name,
            $index: experts.length - index,
            $overlap: index,
            $size: avatarSize
        }, /*#__PURE__*/ react.createElement(Avatar, null, /*#__PURE__*/ react.createElement(expert_avatar/* default */.Z, {
            avatar: expert.avatar,
            displayName: expert.avatarAlt || expert.name,
            size: avatarSize
        })), experts.length === 1 && getSingularExpertText(expert), experts.length > 1 && index === experts.length - 1 && getPluralExpertText());
    }));
};


/***/ }),

/***/ 1946:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ rating)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/rating/rating-helper.ts
var rating_helper = __webpack_require__(51362);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var components_rating = __webpack_require__(34990);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/star/index.js
var star = __webpack_require__(40000);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/expert/components/rating/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  font-weight: 600;\n  font-size: ",
        ";\n  line-height: 1;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: ",
        " ",
        ";\n  background: ",
        ";\n  border-radius: 20px;\n  justify-self: start;\n  font-weight: 600;\n  color: ",
        ";\n  line-height: 1;\n\n  svg {\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 700;\n  font-size: ",
        ";\n  margin-left: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var _measurements = base/* layout.measurements */.bK.measurements, spacing025 = _measurements.spacing025, spacing050 = _measurements.spacing050;
var ExpertRating = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ExpertRating",
    componentId: "sc-0-0"
})(_templateObject());
var Text = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Text",
    componentId: "sc-0-1"
})(_templateObject1(), spacing025, base/* layout.measurements.fontSizeMedium */.bK.measurements.fontSizeMedium);
var Badge = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Badge",
    componentId: "sc-0-2"
})(_templateObject2(), spacing025, spacing050, base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(base/* brandColors.expert */.D2.expert, 1), function(p) {
    return p.theme.colors.base0;
}, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var Stars = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Stars",
    componentId: "sc-0-3"
})(_templateObject3());
var RatingText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "RatingText",
    componentId: "sc-0-4"
})(_templateObject4(), base/* layout.measurements.fontSizeMedium */.bK.measurements.fontSizeMedium, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/badge/index.js
var badge = __webpack_require__(72321);
;// CONCATENATED MODULE: ./src/areas/expert/components/rating/index.tsx






var rating_ExpertRating = function(param) {
    var className = param.className, grade = param.grade, text = param.text, _as = param.as, as = _as === void 0 ? "badge" : _as;
    var rating = rating_helper/* default.toRoundedString */.Z.toRoundedString(grade);
    if (as === "stars") {
        return /*#__PURE__*/ react.createElement(Stars, {
            className: className
        }, /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
            rate: grade,
            expertColors: true,
            size: "large"
        }), " ", /*#__PURE__*/ react.createElement(RatingText, null, rating));
    }
    return /*#__PURE__*/ react.createElement(ExpertRating, {
        className: className
    }, text && /*#__PURE__*/ react.createElement(Text, null, text, ": "), /*#__PURE__*/ react.createElement(badge.Badge, {
        color: "BLUE_INVERTED",
        icon: star/* IconStar */.G,
        text: rating
    }));
};
/* harmony default export */ var rating = (rating_ExpertRating);


/***/ }),

/***/ 21351:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94141);
/* harmony import */ var src_components_translate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37702);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  cursor: pointer;\n  text-align: left;\n  width: max-content;\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  overflow: hidden;\n  font-size: ",
        ";\n  line-height: ",
        ";\n  max-height: ",
        ";\n\n  p {\n    line-height: inherit;\n    font-size: inherit;\n    margin-bottom: ",
        ";\n  }\n\n  &::before {\n    content: ",
        ";\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    background: ",
        ";\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    right: 0;\n    width: 1rem;\n    height: 1rem;\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var ToggleText = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].button.withConfig({
    displayName: "ToggleText",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToActionHover;
});
var LINE_HEIGHT = src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.lineHeight */ .bK.lineHeight;
var TextBlock = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    displayName: "TextBlock",
    componentId: "sc-0-1"
})(_templateObject1(), function(p) {
    return p.fontSize;
}, LINE_HEIGHT, function(p) {
    return p.showAll ? "100%" : "calc((".concat(p.fontSize, " * ").concat(LINE_HEIGHT, ") * ").concat(p.lineCount, ")");
}, function(p) {
    return "calc(".concat(p.fontSize, " * ").concat(LINE_HEIGHT, ")");
}, function(p) {
    return p.showAll ? "" : '"..."';
}, function(p) {
    return p.theme.bg.primary;
}, function(p) {
    return p.theme.bg.primary;
});
var Text = function(param) {
    var text = param.text, _lineCount = param.lineCount, lineCount = _lineCount === void 0 ? 4 : _lineCount, _fontSize = param.fontSize, fontSize = _fontSize === void 0 ? src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.fontSizeNormal */ .bK.measurements.fontSizeNormal : _fontSize, _onExpand = param.// eslint-disable-next-line @typescript-eslint/no-empty-function
    onExpand, onExpand = _onExpand === void 0 ? function() {} : _onExpand;
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), 2), showText = ref[0], setShowText = ref[1];
    var toggleExpand = function() {
        if (!showText) {
            onExpand();
        }
        setShowText(!showText);
    };
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TextBlock, {
        dangerouslySetInnerHTML: {
            __html: text
        },
        showAll: showText,
        lineCount: lineCount,
        fontSize: fontSize
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ToggleText, {
        type: "button",
        onClick: toggleExpand
    }, showText ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_translate__WEBPACK_IMPORTED_MODULE_3__/* .Translate */ .v, {
        domain: "common"
    }, "button.show-less") : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_translate__WEBPACK_IMPORTED_MODULE_3__/* .Translate */ .v, {
        domain: "common"
    }, "button.show-more")));
};
/* harmony default export */ __webpack_exports__["Z"] = (Text);


/***/ }),

/***/ 54712:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": () => (/* binding */ ExpertUserCardSize),
/* harmony export */   "b": () => (/* binding */ ContentTypes)
/* harmony export */ });
var ContentTypes;
(function(ContentTypes) {
    ContentTypes["TEST"] = "AdvizedTest";
    ContentTypes["TOPLIST"] = "AdvizedToplist";
    ContentTypes["TOPLIST_HEADLINE"] = "ToplistHeadline";
    ContentTypes["GUIDE"] = "ExpertGuide";
    ContentTypes["ARTICLE"] = "SearchArticleItem";
    ContentTypes["SPONSORED_ARTICLE"] = "SearchSponsoredArticle";
    ContentTypes["VIDEO"] = "SearchVideoItem";
    ContentTypes["GENERIC_ARTICLE"] = "SearchGenericArticle";
    ContentTypes["EDITORIAL_LANDING_PAGE"] = "SearchEditorialLandingPage";
})(ContentTypes || (ContentTypes = {}));
var ExpertUserCardSize;
(function(ExpertUserCardSize) {
    ExpertUserCardSize["SMALL"] = "SMALL";
    ExpertUserCardSize["MEDIUM"] = "MEDIUM";
})(ExpertUserCardSize || (ExpertUserCardSize = {}));


/***/ }),

/***/ 46674:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": () => (/* binding */ getTranslationByContentType),
/* harmony export */   "t": () => (/* binding */ compareByDate)
/* harmony export */ });
/* harmony import */ var src_areas_expert_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54712);

/**
 * Compare function for sorting Adviced content in arrays
 */ var compareByDate = function(a, b) {
    // If null or undefined, move to bottom of list
    if (!a || !a.publishedAt) return 1;
    if (!b || !b.publishedAt) return -1;
    return parseInt(b.publishedAt, 10) - parseInt(a.publishedAt, 10);
};
var getTranslationByContentType = function(type, t) {
    switch(type){
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_0__/* .ContentTypes.TEST */ .b.TEST:
            return t("expert", "test.test");
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_0__/* .ContentTypes.TOPLIST */ .b.TOPLIST:
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_0__/* .ContentTypes.TOPLIST_HEADLINE */ .b.TOPLIST_HEADLINE:
            return t("expert", "toplist.toplist");
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_0__/* .ContentTypes.GUIDE */ .b.GUIDE:
            return t("expert", "guide.guide");
        default:
            return null;
    }
};


/***/ }),

/***/ 75720:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": () => (/* binding */ PartnerVideoCarousel)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71297);
/* harmony import */ var _product_tabs_sections_main_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27029);



var PartnerVideoCarousel = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "partner-video-carousel";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | partner-video-carousel */ 236).then(__webpack_require__.bind(__webpack_require__, 44820));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(44820);
        }
        return eval("require.resolve")("./partner-video-carousel");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_product_tabs_sections_main_styles__WEBPACK_IMPORTED_MODULE_2__/* .StyledRecommendationsPlaceholder */ .qZ, null)
});


/***/ }),

/***/ 73854:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ product_expert_content)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/areas/product/components/product-context/index.ts
var product_context = __webpack_require__(8466);
// EXTERNAL MODULE: ./src/components/page/index.ts + 3 modules
var page = __webpack_require__(12321);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/card/variants.js
var variants = __webpack_require__(77243);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/like-outlined/index.js
var like_outlined = __webpack_require__(59141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/dislike-outlined/index.js
var dislike_outlined = __webpack_require__(26484);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/expert-content/pros-and-cons/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-auto-flow: column;\n  justify-content: start;\n  column-gap: ",
        ";\n  padding: ",
        ";\n  color: ",
        ";\n  background-color: ",
        ";\n  border-radius: 8px;\n  font-weight: 700;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  width: ",
        "px;\n  height: ",
        "px;\n\n  svg {\n    fill: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var ICON_WRAPPER_SIZE = 24;
var ICON_SIZE = 18;
var ProsConsRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProsConsRow",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.text;
}, function(p) {
    return p.type === "pros" ? p.theme.colors.maybeBlue100 : p.theme.colors.base200;
});
var Icon = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Icon",
    componentId: "sc-0-1"
})(_templateObject1(), ICON_WRAPPER_SIZE, ICON_WRAPPER_SIZE, function(p) {
    return p.theme.text;
});
var H4Text = (0,styled_components_browser_esm["default"])(text_variants.H4Text).withConfig({
    displayName: "H4Text",
    componentId: "sc-0-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/expert-content/pros-and-cons/index.tsx




var ProsAndCons = function(param) {
    var strings = param.strings, type = param.type;
    if (!(strings === null || strings === void 0 ? void 0 : strings.length)) return null;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, strings.filter(function(x) {
        return x;
    }).map(function(string) {
        return string && /*#__PURE__*/ react.createElement(ProsConsRow, {
            key: string,
            type: type
        }, /*#__PURE__*/ react.createElement(Icon, {
            type: type
        }, type === "pros" ? /*#__PURE__*/ react.createElement(like_outlined/* IconLikeOutlined */.q, {
            size: ICON_SIZE
        }) : /*#__PURE__*/ react.createElement(dislike_outlined/* IconDislikeOutlined */.R, {
            size: ICON_SIZE
        })), /*#__PURE__*/ react.createElement(H4Text, null, string));
    }));
};


// EXTERNAL MODULE: ./src/areas/expert/components/expert-user-card/index.tsx + 1 modules
var expert_user_card = __webpack_require__(8454);
// EXTERNAL MODULE: ./src/areas/expert/components/badge/index.tsx
var badge = __webpack_require__(11341);
// EXTERNAL MODULE: ./src/areas/expert/components/rating/index.tsx + 1 modules
var components_rating = __webpack_require__(1946);
// EXTERNAL MODULE: ./src/areas/expert/types.ts
var types = __webpack_require__(54712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/card/index.js
var card = __webpack_require__(33561);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var button_variants = __webpack_require__(25670);
;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/expert-content/test-summary/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  row-gap: ",
        ";\n  width: 100%;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  max-width: 400px;\n  margin: 0 auto;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-auto-flow: row;\n  row-gap: ",
        ";\n\n  span:last-of-type {\n    p {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  height: 100%;\n  object-fit: cover;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n  align-self: stretch;\n  height: auto;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n  min-width: 70%;\n  > :not(:last-child) {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var Summary = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Summary",
    componentId: "sc-0-0"
})(styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var ReadMore = (0,styled_components_browser_esm["default"])(button_variants.OutlinedButton).withConfig({
    displayName: "ReadMore",
    componentId: "sc-0-1"
})(styles_templateObject1());
var TextBlock = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TextBlock",
    componentId: "sc-0-2"
})(styles_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var CardImage = styled_components_browser_esm["default"].img.withConfig({
    displayName: "CardImage",
    componentId: "sc-0-3"
})(_templateObject3());
var Media = (0,styled_components_browser_esm["default"])(card.CardMedia).withConfig({
    displayName: "Media",
    componentId: "sc-0-4"
})(_templateObject4());
var Content = (0,styled_components_browser_esm["default"])(card.CardContent).withConfig({
    displayName: "Content",
    componentId: "sc-0-5"
})(_templateObject5(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);

// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(84234);
;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/expert-content/test-summary/index.tsx













var TestSummary = function(param) {
    var expertTest = param.expertTest;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), linkTo = ref.linkTo, t = ref.t;
    var expert = expertTest.expert, rating = expertTest.rating, title = expertTest.title, plus = expertTest.plus, minus = expertTest.minus, imageWithSize = expertTest.imageWithSize, suitedFor = expertTest.suitedFor, url = expertTest.url;
    var theme = (0,styled_components_browser_esm.useTheme)();
    var src = imageWithSize === null || imageWithSize === void 0 ? void 0 : imageWithSize.src;
    var cardContent = /*#__PURE__*/ react.createElement(react.Fragment, null, src && /*#__PURE__*/ react.createElement(Media, null, /*#__PURE__*/ react.createElement(CardImage, {
        alt: (imageWithSize === null || imageWithSize === void 0 ? void 0 : imageWithSize.alt) || title,
        src: src
    })), /*#__PURE__*/ react.createElement(Content, null, /*#__PURE__*/ react.createElement(text_variants.TitleMediumText, null, /*#__PURE__*/ react.createElement(badge/* Badge */.C, {
        type: types/* ContentTypes.TEST */.b.TEST
    }), ": ", title), /*#__PURE__*/ react.createElement(Summary, null, /*#__PURE__*/ react.createElement(ProsAndCons, {
        type: "pros",
        strings: plus
    }), /*#__PURE__*/ react.createElement(ProsAndCons, {
        type: "cons",
        strings: minus
    })), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(text_variants.TitleMediumText, null, t("expert", "title.grade"), ":"), /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
        as: "stars",
        grade: rating || 0
    })), (suitedFor === null || suitedFor === void 0 ? void 0 : suitedFor.text) && /*#__PURE__*/ react.createElement(TextBlock, null, suitedFor.headline && /*#__PURE__*/ react.createElement("b", null, suitedFor.headline), /*#__PURE__*/ react.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: suitedFor.text
        }
    })), /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
        experts: [
            expert
        ]
    }), /*#__PURE__*/ react.createElement(ReadMore, {
        container: clickable/* Clickable */.P,
        containerProps: {
            to: linkTo("expertTest", {
                semantic_id: url
            })
        },
        style: {
            textAlign: "center"
        },
        fullWidth: true
    }, t("expert", "test.read-more"))));
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(block/* MobileOnly */.iB, null, /*#__PURE__*/ react.createElement(variants/* ColumnCard */.ff, {
        style: {
            background: theme.colors.base0
        }
    }, cardContent)), /*#__PURE__*/ react.createElement(block/* MediumUp */.TD, null, /*#__PURE__*/ react.createElement(variants/* RowCard */.Jz, {
        style: {
            background: theme.colors.base0
        }
    }, cardContent)));
};
/* harmony default export */ var test_summary = (TestSummary);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(29261);
// EXTERNAL MODULE: ./src/areas/expert/components/text/index.tsx
var components_text = __webpack_require__(21351);
// EXTERNAL MODULE: ./src/components/product-image/index.tsx
var product_image = __webpack_require__(95242);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/badge/index.js
var ui_badge = __webpack_require__(72321);
;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/expert-content/toplist-summary/position-in-list.tsx



var PositionInList = function(param) {
    var className = param.className, position = param.position;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement(ui_badge.Badge, {
        className: className,
        text: t("expert", "toplist.product-position", {
            pos: position
        }),
        color: "BLUE"
    });
};


;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/expert-content/toplist-summary/styles.ts
function toplist_summary_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function toplist_summary_styles_templateObject() {
    var data = toplist_summary_styles_taggedTemplateLiteral([
        "\n  height: 140px;\n  object-fit: cover;\n"
    ]);
    toplist_summary_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function toplist_summary_styles_templateObject1() {
    var data = toplist_summary_styles_taggedTemplateLiteral([
        "\n  max-width: 300px;\n  margin: 0 auto;\n"
    ]);
    toplist_summary_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function toplist_summary_styles_templateObject2() {
    var data = toplist_summary_styles_taggedTemplateLiteral([
        "\n  align-self: stretch;\n  height: auto;\n  min-width: 20%;\n"
    ]);
    toplist_summary_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = toplist_summary_styles_taggedTemplateLiteral([
        "\n  > :not(:last-child) {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = toplist_summary_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        ";\n  left: ",
        ";\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






var ProductImage = (0,styled_components_browser_esm["default"])(product_image/* ProductImage */.q).withConfig({
    displayName: "ProductImage",
    componentId: "sc-0-0"
})(toplist_summary_styles_templateObject());
var StyledButton = (0,styled_components_browser_esm["default"])(button_variants.OutlinedButton).withConfig({
    displayName: "StyledButton",
    componentId: "sc-0-1"
})(toplist_summary_styles_templateObject1());
var styles_Media = (0,styled_components_browser_esm["default"])(card.CardMedia).withConfig({
    displayName: "Media",
    componentId: "sc-0-2"
})(toplist_summary_styles_templateObject2());
var styles_Content = (0,styled_components_browser_esm["default"])(card.CardContent).withConfig({
    displayName: "Content",
    componentId: "sc-0-3"
})(styles_templateObject3(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var styles_PositionInList = (0,styled_components_browser_esm["default"])(PositionInList).withConfig({
    displayName: "PositionInList",
    componentId: "sc-0-4"
})(styles_templateObject4(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);

;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/expert-content/toplist-summary/index.tsx














var ToplistSummary = function(param) {
    var product = param.product, toplist = param.toplist;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var theme = (0,styled_components_browser_esm.useTheme)();
    if (!toplist) return null;
    var products = toplist.products;
    var selectedProductIndex = products.findIndex(function(p) {
        return p.id.toString() === product.id.toString();
    });
    if (selectedProductIndex === -1) return null;
    var selectedProduct = products[selectedProductIndex];
    var cardContent = /*#__PURE__*/ react.createElement(react.Fragment, null, product.media.first && /*#__PURE__*/ react.createElement(styles_Media, null, /*#__PURE__*/ react.createElement(styles_PositionInList, {
        position: selectedProductIndex + 1
    }), /*#__PURE__*/ react.createElement(ProductImage, {
        src: product.media.first,
        name: product.name
    })), /*#__PURE__*/ react.createElement(styles_Content, null, /*#__PURE__*/ react.createElement(text_variants.TitleMediumText, null, /*#__PURE__*/ react.createElement(badge/* Badge */.C, {
        type: types/* ContentTypes.TOPLIST */.b.TOPLIST
    }), ": ", toplist.title), selectedProduct && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(list_variants.Column, {
        gap: 0.5,
        style: {
            width: "100%"
        }
    }, /*#__PURE__*/ react.createElement(ProsAndCons, {
        type: "pros",
        strings: [
            selectedProduct.plus
        ]
    }), /*#__PURE__*/ react.createElement(ProsAndCons, {
        type: "cons",
        strings: [
            selectedProduct.minus
        ]
    })), selectedProduct.description && /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(components_text/* default */.Z, {
        lineCount: 8,
        text: selectedProduct.description
    }))), /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
        experts: [
            toplist.expert
        ]
    }), /*#__PURE__*/ react.createElement(StyledButton, {
        container: clickable/* Clickable */.P,
        containerProps: {
            to: toplist.url
        },
        fullWidth: true
    }, t("expert", "toplist.view-the-whole-top-list"))));
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(block/* MobileOnly */.iB, null, /*#__PURE__*/ react.createElement(variants/* ColumnCard */.ff, {
        style: {
            background: theme.colors.base0
        }
    }, cardContent)), /*#__PURE__*/ react.createElement(block/* MediumUp */.TD, null, /*#__PURE__*/ react.createElement(variants/* RowCard */.Jz, {
        style: {
            background: theme.colors.base0
        }
    }, cardContent)));
};
/* harmony default export */ var toplist_summary = (ToplistSummary);

// EXTERNAL MODULE: ./src/components/viewport/index.tsx
var viewport = __webpack_require__(22899);
;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/expert-content/list-of-toplists/styles.ts
function list_of_toplists_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function list_of_toplists_styles_templateObject() {
    var data = list_of_toplists_styles_taggedTemplateLiteral([
        "\n          grid-template-columns: repeat(4, 1fr);\n          column-gap: ",
        ";\n          grid-template-rows: auto;\n        "
    ]);
    list_of_toplists_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function list_of_toplists_styles_templateObject1() {
    var data = list_of_toplists_styles_taggedTemplateLiteral([
        "\n      ",
        "\n    "
    ]);
    list_of_toplists_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function list_of_toplists_styles_templateObject2() {
    var data = list_of_toplists_styles_taggedTemplateLiteral([
        "\n    display: grid;\n    grid-template-rows: repeat(auto-fill, minmax(75px, 1fr));\n    gap: ",
        ";\n\n    ",
        "\n  "
    ]);
    list_of_toplists_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function list_of_toplists_styles_templateObject3() {
    var data = list_of_toplists_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    list_of_toplists_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function list_of_toplists_styles_templateObject4() {
    var data = list_of_toplists_styles_taggedTemplateLiteral([
        "\n  display: grid !important; /* This used to be an inline-style, which overrode the more specific rule that this brings, !important just brings it back to that level */\n  grid-template-columns: 1fr 3fr;\n  width: 100%;\n"
    ]);
    list_of_toplists_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = list_of_toplists_styles_taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = list_of_toplists_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = list_of_toplists_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = list_of_toplists_styles_taggedTemplateLiteral([
        "\n  height: 100%;\n  object-fit: cover;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}





var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-0"
})(list_of_toplists_styles_templateObject3(), function(props) {
    return (0,styled_components_browser_esm.css)(list_of_toplists_styles_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.mediumUp */.BC.mediumUp(list_of_toplists_styles_templateObject1(), props.columnView && (0,styled_components_browser_esm.css)(list_of_toplists_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100)));
});
var StyledCardActionArea = (0,styled_components_browser_esm["default"])(card.CardActionArea).withConfig({
    displayName: "StyledCardActionArea",
    componentId: "sc-0-1"
})(list_of_toplists_styles_templateObject4());
var ExpandButton = (0,styled_components_browser_esm["default"])(button_variants.TextButton).withConfig({
    displayName: "ExpandButton",
    componentId: "sc-0-2"
})(styles_templateObject5(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var Position = (0,styled_components_browser_esm["default"])(text_variants.CaptionText).withConfig({
    displayName: "Position",
    componentId: "sc-0-3"
})(_templateObject6(), function(p) {
    return p.theme.text.callToAction;
});
var ExpertCount = (0,styled_components_browser_esm["default"])(text_variants.CaptionText).withConfig({
    displayName: "ExpertCount",
    componentId: "sc-0-4"
})(_templateObject7(), function(p) {
    return p.theme.text.secondary;
});
var Image = styled_components_browser_esm["default"].img.withConfig({
    displayName: "Image",
    componentId: "sc-0-5"
})(_templateObject8());

;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/expert-content/list-of-toplists/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}









var LIMIT_DESKTOP = 5;
var LIMIT_MOBILE = 2;
var positionsInList = function(toplist, productId) {
    var ref;
    // Returns a comma separated list with the position of all products
    // in a list, and the last item in the list separated with "&".
    var positions = (ref = toplist.toplists) === null || ref === void 0 ? void 0 : ref.map(function(l) {
        return l.products.map(function(p, i) {
            if (p.id === productId) return i + 1;
            return null;
        });
    }).flat().filter(function(p) {
        return p !== null;
    });
    if (!positions) return null;
    if (positions.length === 1) {
        return positions[0].toString();
    }
    return "".concat(positions.slice(0, (positions === null || positions === void 0 ? void 0 : positions.length) - 1).join(", "), " & ").concat(positions[positions.length - 1]);
};
var ListOfToplists = function(param) {
    var toplists = param.toplists, limit = param.limit, productId = param.productId, _columnView = param.columnView, columnView = _columnView === void 0 ? false : _columnView;
    var ref = _slicedToArray((0,react.useState)(false), 2), expanded = ref[0], setExpanded = ref[1];
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var isDesktop = (0,react.useContext)(viewport/* ViewportContext */.R).isDesktop;
    var theme = (0,styled_components_browser_esm.useTheme)();
    var maxAmountOfCards = isDesktop ? limit || LIMIT_DESKTOP : LIMIT_MOBILE;
    var desktopAndColumn = Boolean(columnView && isDesktop);
    var CardComponent = desktopAndColumn ? variants/* ColumnCard */.ff : variants/* RowCard */.Jz;
    var ActionComponent = desktopAndColumn ? card.CardActionArea : StyledCardActionArea;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Wrapper, {
        columnView: desktopAndColumn
    }, toplists.slice(0, !expanded ? maxAmountOfCards : toplists.length).map(function(toplist) {
        var ref, ref1, ref2;
        var list = toplist.toplists[0];
        var image = (ref = list.description) === null || ref === void 0 ? void 0 : ref.find(function(d) {
            return d.type === "image";
        });
        var positions = positionsInList(toplist, productId);
        if (!(image === null || image === void 0 ? void 0 : image.data)) {
            return null;
        }
        return /*#__PURE__*/ react.createElement(CardComponent, {
            key: list.title,
            style: {
                background: theme.colors.base0
            }
        }, /*#__PURE__*/ react.createElement(ActionComponent, {
            container: clickable/* Clickable */.P,
            containerProps: {
                to: (ref1 = list.headlineInfo) === null || ref1 === void 0 ? void 0 : ref1.url
            }
        }, /*#__PURE__*/ react.createElement(card.CardMedia, {
            style: {
                height: "100%"
            }
        }, /*#__PURE__*/ react.createElement(Image, {
            alt: list.title,
            src: image.data
        })), /*#__PURE__*/ react.createElement(card.CardContent, null, toplist.toplists && toplist.toplists.length > 1 && /*#__PURE__*/ react.createElement(ExpertCount, null, t("expert", "guide.lists-expert-plural", {
            count: toplist.toplists.length
        })), /*#__PURE__*/ react.createElement(text_variants.TitleMediumText, null, list.title), /*#__PURE__*/ react.createElement(Position, null, t("expert", "toplist.pos-in-n-lists", {
            n: ((ref2 = toplist.toplists) === null || ref2 === void 0 ? void 0 : ref2.length) || "-1",
            pos: positions || "-"
        })))));
    })), toplists.length > maxAmountOfCards && /*#__PURE__*/ react.createElement(ExpandButton, {
        onClick: function() {
            return setExpanded(function(state) {
                return !state;
            });
        }
    }, expanded ? t("expert", "toplist.view-less-toplists") : t("expert", "toplist.view-all-toplists", {
        count: toplists.length
    })));
};
/* harmony default export */ var list_of_toplists = (ListOfToplists);

// EXTERNAL MODULE: ./src/areas/product/components/carousel-products/components/partner-video-carousel/index.tsx
var partner_video_carousel = __webpack_require__(75720);
;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/expert-content/styles.ts
function expert_content_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function expert_content_styles_templateObject() {
    var data = expert_content_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    expert_content_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function expert_content_styles_templateObject1() {
    var data = expert_content_styles_taggedTemplateLiteral([
        "\n  display: block;\n  font-weight: 700;\n  margin-bottom: ",
        ";\n"
    ]);
    expert_content_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledExpertContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledExpertContent",
    componentId: "sc-0-0"
})(expert_content_styles_templateObject(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150);
var StyledSubtitle = (0,styled_components_browser_esm["default"])(text_variants.H3Text).withConfig({
    displayName: "StyledSubtitle",
    componentId: "sc-0-1"
})(expert_content_styles_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);

;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/expert-content/product-expert-content.tsx









var ProductExpertContent = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,app_context/* useAppContext */.bp)(), market = ref7.market, t = ref7.t;
    var product = (0,product_context/* useProductContext */.$h)().product;
    var partnerVideosEnabled = Boolean(market.partnerVideosEnabled);
    var expertsEnabled = (ref = market.experts) === null || ref === void 0 ? void 0 : ref.enabled;
    if (!expertsEnabled) return null;
    var expertTest = (product === null || product === void 0 ? void 0 : (ref1 = product.expertContent) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.selected) === null || ref2 === void 0 ? void 0 : ref2.__typename) === "ProductPageExpertTest" ? product.expertContent.selected : null;
    var expertToplist = (product === null || product === void 0 ? void 0 : (ref3 = product.expertContent) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.selected) === null || ref4 === void 0 ? void 0 : ref4.__typename) === "ProductPageToplist" ? product.expertContent.selected : null;
    var expertToplists = product === null || product === void 0 ? void 0 : (ref5 = product.expertContent) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.toplists) === null || ref6 === void 0 ? void 0 : ref6.map(function(toplist) {
        return toplist;
    });
    return /*#__PURE__*/ react.createElement(page/* PageSection */.NP, {
        noBorder: true,
        recessed: true
    }, expertTest && /*#__PURE__*/ react.createElement(StyledExpertContent, null, /*#__PURE__*/ react.createElement(StyledSubtitle, null, t("expert", "test.test-plural")), /*#__PURE__*/ react.createElement(test_summary, {
        productId: product.id,
        expertTest: expertTest
    })), !expertTest && expertToplist && /*#__PURE__*/ react.createElement(StyledExpertContent, null, /*#__PURE__*/ react.createElement(StyledSubtitle, null, t("expert", "toplist.toplist-plural")), /*#__PURE__*/ react.createElement(toplist_summary, {
        product: product,
        toplist: expertToplist
    })), expertToplists && expertToplists.length > 1 ? /*#__PURE__*/ react.createElement(StyledExpertContent, null, /*#__PURE__*/ react.createElement(StyledSubtitle, null, t("expert", "toplist.product-in-lists", {
        n: expertToplists.length
    })), /*#__PURE__*/ react.createElement(list_of_toplists, {
        toplists: expertToplists,
        columnView: true,
        limit: 4,
        productId: product.id
    })) : null, market.experts.enabled && partnerVideosEnabled && /*#__PURE__*/ react.createElement(partner_video_carousel/* PartnerVideoCarousel */.W, {
        productId: product.id
    }));
};
/* harmony default export */ var product_expert_content = (/*#__PURE__*/react.memo(ProductExpertContent));


/***/ })

}]);